var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-sub-title-wrapper"},[_c('h3',_vm._b({staticClass:"section-sub-title",domProps:{"innerHTML":_vm._s(_vm.text)}},'h3',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }